import "./CardSoftware.css";

const CardSoftware = ({ data }) => {
	return (
		<div className="card-software">
			<div className="card-software-icon-container">
				<img
					alt={data["name"]}
					src={require("../../assets/" + data["icon"])}
					className="card-software-icon-img"
				/>
			</div>
			<h4 className="card-software-name h4-bold">{data["name"]}</h4>
		</div>
	);
};

export default CardSoftware;
